import React, { useEffect, useState } from "react";
import { TextField, TextFieldProps } from "@mui/material";

interface DebouncedTextFieldProps {
  debounce?: number;
  onTextChange: (value: string) => void;
}

export function DebouncedTextField({
  // value,
  onTextChange,
  debounce = 500,
  ...props
}: DebouncedTextFieldProps & TextFieldProps) {
  const [localValue, setLocalValue] = useState("");

  useEffect(() => {
    const timeout = setTimeout(() => {
      onTextChange(localValue);
    }, debounce);
    return () => clearTimeout(timeout);
  }, [localValue, debounce, onTextChange]);

  return (
    <TextField
      value={localValue}
      onChange={(e) => setLocalValue(e.target.value)}
      {...props}
    />
  );
}
